import React from 'react';
import {
  AtlassianNavigation,
  PrimaryButton,
  Create as CreateButton,
} from '@atlaskit/atlassian-navigation';

import { LinkWithRef } from '@/components/primitive';
import FeedbackLink from '@/components/primitive/feeback-link';
import { useLocationController } from '@/controllers';
import { flex, spaceGapCozy } from '@/styles';

import * as styles from './styles';
import NavSettings from './nav-settings';
import NavLogo from './nav-logo';
import NavProfile from './nav-profile';
import NavHelp from './nav-help';
import NavSearch from './nav-search';

type NavProps = {
  onCreate: () => void;
};

const Nav: React.FC<NavProps> = ({ onCreate }) => {
  const { isSearchPage, isHomepage } = useLocationController();

  return (
    <div css={[styles.root, styles.nav]}>
      <AtlassianNavigation
        label="Tome"
        renderSettings={NavSettings}
        renderProductHome={NavLogo}
        renderCreate={() => <CreateButton text="Create" onClick={onCreate} />}
        renderHelp={NavHelp}
        renderSearch={() => (
          <span css={[flex, spaceGapCozy]}>
            <FeedbackLink />
            <NavSearch />
          </span>
        )}
        primaryItems={[
          <PrimaryButton key="home" href="/" isHighlighted={isHomepage} component={LinkWithRef}>
            Home
          </PrimaryButton>,
          <PrimaryButton
            key="search"
            href="/search"
            isHighlighted={isSearchPage}
            component={LinkWithRef}
          >
            Search
          </PrimaryButton>,
        ]}
        renderProfile={NavProfile}
      />
    </div>
  );
};

export default Nav;
